import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface DemoProduct {
  name: string;
  type: string;
  serialNumber: string;
  salesOrg: string;
  language: string;
  available: boolean;
}

interface DemoLocale {
  salesOrganization: string;
  country: string;
  language: string;
  displayCountry: string;
  displayLanguage: string;
  serialNumber?: string;
  productName?: string;
}

@Component({
  selector: 'app-internal-demo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './internal-demo.component.html',
  styleUrls: ['./internal-demo.component.scss']
})
export class InternalDemoComponent {

  readonly deProducts: DemoProduct[] = [
    {
      name: 'Vitodens 200-W',
      type: 'B2KF-19',
      serialNumber: '7722313001158125',
      salesOrg: '0500',
      language: 'de',
      available: true
    },
    {
      name: 'Vitocal 250-A',
      type: 'AWO-E-AC 251.A16',
      serialNumber: '7988190510317199',
      salesOrg: '0500',
      language: 'de',
      available: true
    },
    {
      name: 'Vitocal 150-A',
      type: 'AWMOF-151.A1.08-230-V002',
      serialNumber: '7988247501362123',
      salesOrg: '0500',
      language: 'de',
      available: true
    }
  ];

  readonly locales: DemoLocale[] = [
    { salesOrganization: '0500', country: 'DE', language: 'de', displayCountry: 'Deutschland', displayLanguage: 'Deutsch', serialNumber: '7722313001158125', productName: 'Vitodens 200-W' },
    { salesOrganization: '0600', country: 'FR', language: 'fr', displayCountry: 'France', displayLanguage: 'Français', serialNumber: '7733735501723126', productName: 'Vitocal 111-S' },
    { salesOrganization: '5000', country: 'AT', language: 'de', displayCountry: 'Österreich', displayLanguage: 'Deutsch', serialNumber: '7988398501032124', productName: 'Vitodens 100-W' },
    { salesOrganization: '5900', country: 'NL', language: 'nl', displayCountry: 'Nederland', displayLanguage: 'Nederlands', serialNumber: '7571044001061129', productName: 'Vitodens 200-W' },
    { salesOrganization: '6000', country: 'BE', language: 'nl', displayCountry: 'België', displayLanguage: 'Nederlands', serialNumber: '7988244501005128', productName: 'Vitocal 150-A' },
    { salesOrganization: '6100', country: 'LU', language: 'de', displayCountry: 'Luxemburg', displayLanguage: 'Deutsch', serialNumber: '7988235501059129', productName: 'Vitocal 250-A' },
    { salesOrganization: '6200', country: 'CH', language: 'de', displayCountry: 'Schweiz', displayLanguage: 'Deutsch', serialNumber: '7727502001285121', productName: 'Vitocal 200-A' },
    { salesOrganization: '6600', country: 'DK', language: 'da', displayCountry: 'Danmark', displayLanguage: 'Dansk', serialNumber: '7722310003123120', productName: 'Vitodens 200-W' },
    { salesOrganization: '6800', country: 'GB', language: 'en', displayCountry: 'United Kingdom', displayLanguage: 'English', serialNumber: '7098719501113129', productName: 'Vitodens 111-W' },
    { salesOrganization: '7100', country: 'ES', language: 'es', displayCountry: 'España', displayLanguage: 'Español', serialNumber: '7544694502563125', productName: 'Vitodens 100-W' },
    { salesOrganization: '7200', country: 'IT', language: 'it', displayCountry: 'Italia', displayLanguage: 'Italiano', serialNumber: '7672194401780125', productName: 'Vitocal 151-A' },
    { salesOrganization: '7300', country: 'IT', language: 'it', displayCountry: 'Italia (7300)', displayLanguage: 'Italiano', serialNumber: '3210876501006126', productName: 'Vitocal 250-A' },
    { salesOrganization: '7400', country: 'RS', language: 'sr', displayCountry: 'Serbia', displayLanguage: 'Srpski', serialNumber: '7987387424121108', productName: 'Vitodens 050-W' },
    { salesOrganization: '7500', country: 'SI', language: 'sl', displayCountry: 'Slovenija', displayLanguage: 'Slovenščina', serialNumber: '7987387430708102', productName: 'Vitodens 050-W' },
    { salesOrganization: '7600', country: 'HR', language: 'hr', displayCountry: 'Hrvatska', displayLanguage: 'Hrvatski', serialNumber: '7959976206072102', productName: 'Vitodens 050-W' },
    { salesOrganization: '7700', country: 'RO', language: 'ro', displayCountry: 'România', displayLanguage: 'Română', serialNumber: '7098459506860108', productName: 'Vitodens 050-W' },
    { salesOrganization: '7800', country: 'BG', language: 'bg', displayCountry: 'България', displayLanguage: 'Български', serialNumber: '7098702501031128', productName: 'Vitodens 100-W' },
    { salesOrganization: '7900', country: 'SK', language: 'sk', displayCountry: 'Slovenská republika', displayLanguage: 'Slovenčina', serialNumber: '7733746202498121', productName: 'Vitocal 222-S' },
    { salesOrganization: '8000', country: 'TR', language: 'tr', displayCountry: 'Türkiye (8000)', displayLanguage: 'Türkçe', serialNumber: '7571044601004106', productName: 'Vitodens 200-W' },
    { salesOrganization: '8100', country: 'US', language: 'en', displayCountry: 'United States', displayLanguage: 'English', serialNumber: '7721353200022125', productName: 'Vitocrossal 200 CI2' },
    { salesOrganization: '8700', country: 'LT', language: 'lt', displayCountry: 'Lietuva', displayLanguage: 'Lietuvių', serialNumber: '7727500501731124', productName: 'Vitocal 111-S' },
    { salesOrganization: '8800', country: 'FI', language: 'fi', displayCountry: 'Suomi', displayLanguage: 'Suomi', serialNumber: '7727864213579123', productName: 'Vitocal 200-S' },
    { salesOrganization: '8900', country: 'LV', language: 'lv', displayCountry: 'Latvija', displayLanguage: 'Latviešu', serialNumber: '7098459523009108', productName: 'Vitodens 050-W' },
    { salesOrganization: '9200', country: 'UA', language: 'uk', displayCountry: 'Україна', displayLanguage: 'Українська', serialNumber: '7571694113451105', productName: 'Vitopend 100-W' },
    { salesOrganization: '9500', country: 'PL', language: 'pl', displayCountry: 'Polska', displayLanguage: 'Polski', serialNumber: '7098459521873107', productName: 'Vitodens 050-W' },
    { salesOrganization: '9600', country: 'SE', language: 'sv', displayCountry: 'Sverige', displayLanguage: 'Svenska', serialNumber: '7975025301059124', productName: 'Vitocal 222-G' },
    { salesOrganization: '9700', country: 'CZ', language: 'cs', displayCountry: 'Česká republika', displayLanguage: 'Čeština', serialNumber: '7733737203121125', productName: 'Vitocal 200-S' },
    { salesOrganization: '9800', country: 'HU', language: 'hu', displayCountry: 'Magyarország', displayLanguage: 'Magyar', serialNumber: '7733738404508128', productName: 'Vitocal 200-S' },
    { salesOrganization: '9900', country: 'CA', language: 'en', displayCountry: 'Canada', displayLanguage: 'English', serialNumber: '7560854102028129', productName: 'Vitodens 100-W' },
    { salesOrganization: '1470', country: 'TR', language: 'tr', displayCountry: 'Türkiye (1470)', displayLanguage: 'Türkçe', serialNumber: '7571694400373103', productName: 'Vitopend 100-W' },
  ];

  getProductUrl(product: DemoProduct): string {
    return `/product-information/${product.salesOrg}/${product.language}/${product.serialNumber}`;
  }

  getLocaleUrl(locale: DemoLocale): string | null {
    if (!locale.serialNumber) return null;
    return `/product-information/${locale.salesOrganization}/${locale.language}/${locale.serialNumber}`;
  }

  getFlagEmoji(country: string): string {
    const flags: Record<string, string> = {
      DE: '🇩🇪', FR: '🇫🇷', AT: '🇦🇹', NL: '🇳🇱', BE: '🇧🇪', LU: '🇱🇺',
      CH: '🇨🇭', DK: '🇩🇰', GB: '🇬🇧', ES: '🇪🇸', IT: '🇮🇹', RS: '🇷🇸',
      SI: '🇸🇮', HR: '🇭🇷', RO: '🇷🇴', BG: '🇧🇬', SK: '🇸🇰', US: '🇺🇸',
      LT: '🇱🇹', FI: '🇫🇮', LV: '🇱🇻', RU: '🇷🇺', UA: '🇺🇦', CN: '🇨🇳',
      PL: '🇵🇱', SE: '🇸🇪', CZ: '🇨🇿', HU: '🇭🇺', CA: '🇨🇦', TR: '🇹🇷',
      VI: '🌍'
    };
    return flags[country] ?? '🏳️';
  }
}
